import * as React from 'react';

export interface ISimpleChoiceDialogProps {
    title: string;
    content: string;
    leftChoiceText: string;
    leftChoiceClick(): void;
    rightChoiceText: string;
    rightChoiceClick(): void;
}

export const SimpleChoiceDialog = (props: ISimpleChoiceDialogProps) =>  {
    return (
        <div className="small-popup-dialog-root">
            <div className="title primary-style" >
                <h3>{props.title}</h3>
            </div>
            <div className="content-container">
                <p>{props.content}</p>
                <div className="buttons-row">
                    <button
                        className="dialog-button primary-style"
                        onClick={() => props.leftChoiceClick()}>
                        {props.leftChoiceText}
                    </button>
                    <button
                        className="dialog-button primary-style"
                        onClick={() => props.rightChoiceClick()}>
                        {props.rightChoiceText}
                    </button>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/App/shared/components/simple-choice.dialog.tsx